/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 * Private Route for react-router that redirects unauthenticated routes to /login page.
 */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from 'stores/RootStore';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const stores = useStores();
  const { isAuth, isListening } = stores.authStore;
  const localAuth = localStorage.getItem('authUser');

  if (isListening) {
    stores.appStore.debug(`PrivateRoute [route] - Listening for isAuth = true.  isAuth: ${isAuth}`);
  }

  return localAuth && !isAuth ? null : (
    <Route {...rest} render={props => (isAuth ? <Component {...props} /> : <Redirect to='/login' />)} />
  );
};

export default observer(PrivateRoute);
